import store from '@/store'

export default async (to, from, next) => {
  try {
    store.dispatch('wait/start', 'app loading', { root: true })

    await store.dispatch('SystemConfig/fetchSystemConfigs', 'MAXIMUM_PERIOD_PRE_ORDER')

    next()
  } catch (error) {
    throw new Error(error)
  } finally {
    store.dispatch('wait/end', 'app loading', { root: true })
  }
}
